<link href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/5.15.4/css/all.min.css" rel="stylesheet">

<div id ="change" style="background-color: black;transition: background-color 4s;" >
  <!--<div id="loader" class="loader-container" *ngIf="showLoader">
    <img src="assets/images/emsLoader.gif" alt="Loading..." class="loader-gif">
</div>-->
<button style="float: right;background-color: transparent;" (click)="toggleBackground()"><i id="icon" class="fas fa-moon" style="color: orange;"></i></button>
  <div style="padding: 1%;">

  

    <ngx-ui-loader [loaderId]="'emsDashboard'"></ngx-ui-loader>

    <div class="row" style="padding:3px;">

      <div class="col-md-3 " style="color: white;">
        <div style="height: 6vh;background-color:rgb(38, 149, 114) ;">
          <p style="font-size: 4vh;text-align: center;"><b>TOTAL METERS</b> <b style="cursor: pointer;" class="totalTransformerr" (click)="popupTable('total','')">&nbsp;&nbsp;&nbsp;<u>{{ totalMeters }}</u></b></p>
        </div>
        <div class="meterStatus">
          <div style="background-color: #14721F;" class="box"><b style="font-size: 2vh;">ONLINE</b><br><b style="font-size: 4vh;cursor: pointer;" (click)="popupTable('online','')"><u> {{onlineMeters}}</u></b></div>
          <div style="background-color:rgb(197, 65, 48);" class="box"><b style="font-size: 2vh;">ALERTS</b><br><b style="font-size: 4vh;cursor: pointer;" (click)="popupTable('alert','')"><u>{{alertMeters}}</u></b></div>
      </div>
      <div class="meterStatus">
        <div style="background-color: rgb(35, 100, 104);;" class="box"><b style="font-size: 2vh;">NORMAL</b><br><b style="font-size: 4vh;cursor: pointer;" (click)="popupTable('normal','')"><u> {{normalMeters}}</u></b></div>
        <div style="background-color:rgb(109, 109, 109);" class="box"><b style="font-size: 2vh;">OFFLINE</b><br><b style="font-size: 4vh;cursor: pointer;" (click)="popupTable('offline','')"><u>{{offlineMeters}}</u></b></div>
    </div>
    
        <!--<mat-card class="paddingt status-card" style="margin: 1%;background-color: rgba(0, 0, 0, 0.5); border: 2px solid rgba(70, 41, 41, 0.5); height: 100%;">      
          <mat-card-content>
            <div style="padding: 4px;">
              <table style="width: 100%; font-weight: bold;">
                <tbody class="fontSize">  
                  <tr>
                    <td><p style="margin: 0;"><span style="color: rgb(0, 255, 174);">●</span> Total Meters</p></td>
                    <td>
                      <a><b style="cursor: pointer; color: rgb(239, 128, 0);" class="totalTransformerr" (click)="popupTable('total','')">&nbsp;&nbsp;:&nbsp;{{ totalMeters }}</b></a>
                    </td>
                  </tr>
                  <tr>
                    <td><p style="margin: 0;"><span style="color: green;">●</span> Online Meters</p></td>
                    <td>
                      <a><b style="cursor: pointer; color: rgb(239, 128, 0);" class="onlinee" (click)="popupTable('online','')">&nbsp;&nbsp;:&nbsp;{{ onlineMeters }}</b></a>
                    </td>
                  </tr>
                  <tr>
                    <td><p style="margin: 0;"><span style="color: red;">●</span> Alert Meters</p></td>
                    <td>
                      <a><b style="cursor: pointer; color: rgb(239, 128, 0);" class="alertt" (click)="popupTable('alert','')">&nbsp;&nbsp;:&nbsp;{{ alertMeters }}</b></a>
                    </td>
                  </tr>
                  <tr>
                    <td><p style="margin: 0;"><span style="color: rgb(0, 242, 255);">●</span> Normal Meters</p></td>
                    <td>
                      <a><b style="cursor: pointer; color: rgb(239, 128, 0);" class="normall" (click)="popupTable('normal','')">&nbsp;&nbsp;:&nbsp;{{ normalMeters }}</b></a>
                    </td>
                  </tr>
                  <tr>
                    <td><p style="margin: 0;"><span style="color: black;">●</span> Offline Meters</p></td>
                    <td>
                      <a><b style="cursor: pointer; color: rgb(239, 128, 0);" class="offlinee" (click)="popupTable('offline','')">&nbsp;&nbsp;:&nbsp;{{ offlineMeters }}</b></a>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </mat-card-content>
          
        </mat-card>-->
      </div>
      
      <div class="col-md-3 paddingt " style="color: #FFFFFF;background-color: rgba(89, 25, 25, 0.897);;">
        <div style="text-align: center;font-size: 2vh;color: red;"><b>ALERT COUNT</b></div>
        <div class="meterStatus " style="align-items: left;">
          <div class="box alertCount" ><b style="font-size: 2vh;" (click)="popupTablealert('lowpf',lowPowerFactor)">LOW PF : <u style="color: rgb(168, 188, 255);">{{lowPowerFactor || 0}}</u></b></div>
          <div class="box alertCount" ><b style="font-size: 2vh;" (click)="popupTablealert('overload',overload)">OVERLOAD : <u style="color: rgb(168, 188, 255);">{{overload || 0}}</u></b></div>
        </div>
        <div class="meterStatus" style="align-items: left;">
          <div class="box alertCount" ><b style="font-size: 2vh;" (click)="popupTablealert('lowvlot',voltageLow)">LOW VOLTAGE : <u style="color: rgb(168, 188, 255);">{{voltageLow || 0}}</u></b></div>
          <div class="box alertCount" ><b style="font-size: 2vh;" (click)="popupTablealert('highvolt',voltageHigh)">HIGH VOLTAGE : <u style="color: rgb(168, 188, 255);">{{voltageHigh || 0}}</u></b></div>
        </div>
        <div class="meterStatus" style="align-items: left;">
          <div class="box alertCount" ><b style="font-size: 2vh;" (click)="popupTablealert('harmonics',harmonics)">HORMONICS : <u style="color: rgb(168, 188, 255);">{{harmonics || 0}}</u></b></div>
          <div class="box alertCount" ><b style="font-size: 2vh;" (click)="popupTablealert('disconnected',communicationFailure)">DISCONNECTED : <u style="color: rgb(168, 188, 255);">{{communicationFailure || 0}}</u></b></div>
        </div>
        <!--<mat-card class="paddingt fontSize" style="padding: 0;">
            <mat-card-header class="alert-card-header">
                <b class="alert-title ">Alert Section</b>
            </mat-card-header>
            <mat-card-content class="alert-card-content fontSize">
                <ul class="alert-list">
                    <li class="alert-item">
                        <span class="alert-type">Low Power Factor:</span>
                        <span class="alert-count" style="cursor: pointer;"(click)="popupTablealert('lowpf','')">{{lowPowerFactor || 0}}</span>
                    </li>
                    <li class="alert-item">
                        <span class="alert-type">Communication Failure:</span>
                        <span class="alert-count" style="cursor: pointer;" >{{communicationFailure || 0}}</span>
                    </li>
                    <li class="alert-item">
                        <span class="alert-type">Overload Alert:</span>
                        <span class="alert-count" style="cursor: pointer;" >{{overload || 0}}</span>
                    </li>
                    <li class="alert-item">
                        <span class="alert-type">Voltage Low:</span>
                        <span class="alert-count" style="cursor: pointer;" >{{voltageLow || 0}}</span>
                    </li>
                    <li class="alert-item">
                        <span class="alert-type">Voltage High:</span>
                        <span class="alert-count" style="cursor: pointer;" >{{voltageHigh || 0}}</span>
                    </li>
                    <li class="alert-item">
                        <span class="alert-type">Harmonics:</span>
                        <span class="alert-count" style="cursor: pointer;" >{{harmonics || 0}}</span>
                    </li>
                </ul>
            </mat-card-content>
        </mat-card> -->
    </div>
      


      <div class="col-md-6 paddingt">
        

        <mat-card  style="padding: 0px;background-color:rgb(86, 49, 49) ;height: 26vh;">
          <mat-card-header style="background-color:rgb(86, 49, 49); justify-content: space-between;">
              <b class="fontSize" style="text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.5);color: #cf0000;float: left;">Live Alerts</b>
                  <i style="padding: 1%;height: 40%;width: 5%;color: #FFFFFF;" (click)="openTodayAlertsModal()" class="fa fa-expand"></i>
          </mat-card-header>
          <mat-card-content style="height: 22vh;overflow: auto;scroll-behavior: smooth;padding:1px;">
              <ng-container  >
                  <table class="alerts-table fontSize" id="alerttabledata"  >
                      <thead >
                        <tr style=" width: fit-content;  position: sticky;">
                          <th>Date</th>
                          <th>Time</th>
                          <th>Parameter</th>
                          <th>Asset Name</th>
                          <th>Actual Value</th>
                          <th>Threshold Value</th>
                          <th>Meter ID</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr  class="scrolling-text" *ngFor="let arr of LiveAlertsArray.slice().reverse()">
                          <td >{{ arr.date }}</td>
                          <td>{{ arr.time }}</td>
                          <td>{{ arr.parametername.replace('ap', '') }}</td>
                          <td>{{ arr.assetName }}</td>
                          <td style="text-align: center;">{{ arr.actualvalue}}</td>
                          <td style="text-align: center;">{{arr.thresholdvalue }}</td>
                          <td>{{ arr.energyMeterId }}</td>
                        </tr>
                      </tbody>
                    </table>
              </ng-container>
          </mat-card-content>
          </mat-card>
     </div>
    </div>

    <div class="row" style="padding:3px;">
      <div class="col-md-4 Mpadding">
        <mat-card class="Mpadding energy-card-container" style="padding:0px;">
          <mat-card-header style="position: sticky; top: 0; z-index: 1;" class="energy-card-header fontSize" >
             <b style="text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.5);color: #FFFFFF;display: flex;justify-content: space-between;align-items: center;">Meters Data</b>&nbsp;&nbsp;&nbsp;&nbsp;
             <input style="float: right;" type="text" [(ngModel)]="searchQuery" [placeholder]="searchname" />
          </mat-card-header> 
          <mat-card-content style="height: 22vh;overflow:auto;" >
            <div class="energy-container" >
              <ng-container  *ngFor="let mainMeter of filterData()">
                <ng-container *ngIf="!isMain">
                  <div class="sub-meter">
                    <div class="sub-meter-header" (click)="mainMeter.showDetails = !mainMeter.showDetails">
                      <!-- Energy Icon (Font Awesome Bolt Icon) -->
                      <img src="assets/images/meters.png" alt="Power Factor" style="width:20px; height:auto; margin-right:10px;" />
                      <!-- Meter Name -->
                      <h5 class="sub-meter-name">
                        {{ mainMeter.meterid }} ({{ mainMeter.description }})
                      </h5>
                      <!-- Toggle Button -->
                      <span class="toggle-button">{{ mainMeter.showDetails ? '-' : '+' }}</span>
                    </div>
                    <!-- Meter Details (Visible on Click) -->
                    <div class="energy-consumption" *ngIf="mainMeter.showDetails" style="display:flex;color: #FFFFFF;">
                      <p style="margin:10px"><i class="fa fa-bolt"></i> <b style="margin:10px">Kwh:</b> {{ mainMeter.logsystemkwh | number:'1.2-2' }}</p>
                      <p style="margin:10px"><i class="fa fa-tachometer-alt"></i> <b style="margin:10px">Avg PF:</b> {{ mainMeter.logavgpf | number:'1.2-2' }}</p>
                      <p style="margin:10px"><i class="fa fa-bolt"></i> <b style="margin:10px">Kvah:</b> {{ mainMeter.logsystemkvah | number:'1.2-2' }}</p>
                    </div>
                  </div>
                </ng-container>
                <ng-container *ngIf="mainMeter.type === 'Main'">
                  <!-- Main Meter Row -->
                  <div class="main-meter" (click)="mainMeter.expanded = !mainMeter.expanded">
                    <div class="energy-header fontSize">
                      <b class="energy-source fontSize">
                        
                        <img src="assets/images/meters.png" height="20vh"> {{ mainMeter.meterid }} ({{ mainMeter.description }})
                      </b>
                      <!-- Toggle Icon -->
                      <span class="toggle-icon "><b class="fontSize">{{ mainMeter.expanded ? '▲' : '▼' }}</b></span>
                    </div>
                    <div class="energy-details " style="display: flex;flex-direction: row;" *ngIf="mainMeter.expanded">
                      <p class="fontSize" style="margin-bottom: 0rem;padding-left: 7%;"><b><i class="fa fa-bolt"></i>&nbsp;&nbsp;Kwh:</b> {{ mainMeter.logsystemkwh | number:'1.2-2' }}</p>
                      <p class="fontSize" style="margin-bottom: 0rem; padding-left: 7%;"><b>Avg PF:</b> {{ mainMeter.logavgpf | number:'1.2-2' }}</p>
                      <p class="fontSize" style="margin-bottom: 0rem;padding-left: 7%;"><b>Kvah:</b> {{ mainMeter.logsystemkvah | number:'1.2-2' }}</p>
                    </div>
          
                    <!-- Sub Meter Section -->
                    <div *ngIf="mainMeter.expanded" class="sub-meters fontSize">
                      <ng-container *ngFor="let subMeter of alldataofmonth">
                        <ng-container *ngIf="subMeter.type === mainMeter.meterid">
                          <div class="sub-meter">
                            <h5 class="sub-meter-name ">
                              <b style="padding-left:2% ;" class="fontSize">{{ subMeter.meterid }} ({{ subMeter.description }})</b>
                            </h5>
                            <div class="energy-consumption" style="display: flex;flex-direction: row;">
                              <p class="fontSize" style="padding-left: 7%;"><i class="fa fa-bolt"></i><b>Kwh :</b> {{ subMeter.logsystemkwh | number:'1.2-2' }}</p>
                              <p class="fontSize" style="padding-left: 7%;"><i class="fa fa-tachometer-alt"></i><b> Avg PF : </b>{{ subMeter.logavgpf | number:'1.2-2' }}</p>
                              <p class="fontSize" style="padding-left: 7%;"><i class="fa fa-bolt"></i><b>Kvah : </b>{{ subMeter.logsystemkvah | number:'1.2-2' }}</p>
                            </div>
                          </div>
                        </ng-container>
                      </ng-container>
                    </div>
                  </div>
                </ng-container>
              </ng-container>
            </div>
          </mat-card-content>
        </mat-card>
      </div>
      <div class="col-md-4 Mpadding">
        
        <div class="containers">
          <div class="screen-name row">
           MAIN METER
          </div>
          <div class="secondscreens" *ngIf="showInfo === 'first'">
            <div class="row rowheight">
                <div class="col" id="kWh" style="padding: 0; display: flex; align-items: center;">
                    <b [class.blink]="blinkState" style="flex: 1; padding-right: 5px;">{{latestkwh_p}}</b>
                    <div class="unit" style="flex: 0 0 auto; padding: 1px;">kWh</div>
                </div>
            </div>
        
            <div class="row rowheight">
                <div class="col" id="kWh" style="padding: 0; display: flex; align-items: center;">
                    <span  [class.blink]="blinkState" style="flex: 1; padding-right: 5px;">{{totalKvah}}</span>
                    <div class="unit" style="flex: 0 0 auto; padding: 1px;">kVAh</div>
                </div>
            </div>
        
            <div class="row rowheight">
                <div class="col" id="kWh" style="padding: 0; display: flex; align-items: center;">
                    <span  [class.blink]="blinkState" style="flex: 1; padding-right: 5px;">{{logavgpf}}</span>
                    <div class="unit" style="flex: 0 0 auto; padding: 1px;">AvgPF</div>
                </div>
            </div>
        </div>
        
          
          <!--
          <div class="secondscreens" *ngIf="showInfo === 'second'">
            <h6 style=" font-family: 'DigitalFont';margin:0px;font-weight: bold; font-size: 24px;">
              Voltage
            </h6>
            <div class="row">
              <div class="col-md-6">
                <div>
                <a style=" font-family: 'DigitalFont';
                    font-weight: bold;
                    font-size: 21px;
                    margin-right: 116px;"> 1 </a>
                    </div>
                    <div>
                <a style=" font-family: 'DigitalFont';
                    font-weight: bold;
                    font-size: 21px;
                    margin-right: 116px;"> 2 </a></div>
                  <div>
               <a style=" font-family: 'DigitalFont';
                     font-weight: bold;
                     font-size: 21px;
                     margin-right: 116px;"> 3 </a>
                     </div>
              </div>
              <div class="col-md-6">
                <a style=" font-family: 'DigitalFont';
                  font-weight: bold;
                  font-size: 21px;
                 
                 "> 23.25 </a> <br>
                <a style=" font-family: 'DigitalFont';
                  font-weight: bold;
                  font-size: 21px;
                 
                 "> 23.25 </a> <br>
                <a style=" font-family: 'DigitalFont';
                   font-weight: bold;
                   font-size: 21px;
                  
                  "> 23.25 </a>
              </div>
            </div>
          </div>
          <div class="secondscreens" *ngIf="showInfo === 'third'">
            <h6 style=" font-family: 'DigitalFont';margin:0px;font-weight: bold; font-size: 24px;">
              Current
            </h6>
            <div class="row">
              <div class="col-md-6">
                <div>
                <a style=" font-family: 'DigitalFont';
                    font-weight: bold;
                    font-size: 21px;
                    margin-right: 116px;"> I1 </a>
                    </div>
                    <div>
                <a style=" font-family: 'DigitalFont';
                    font-weight: bold;
                    font-size: 21px;
                    margin-right: 116px;"> I2 </a></div>
                  <div>
               <a style=" font-family: 'DigitalFont';
                     font-weight: bold;
                     font-size: 21px;
                     margin-right: 116px;"> I3 </a>
                     </div>
              </div>
              <div class="col-md-6">
                <a style=" font-family: 'DigitalFont';
                  font-weight: bold;
                  font-size: 21px;
                 
                 "> 23.25 </a> <br>
                <a style=" font-family: 'DigitalFont';
                  font-weight: bold;
                  font-size: 21px;
                 
                 "> 23.25 </a> <br>
                <a style=" font-family: 'DigitalFont';
                   font-weight: bold;
                   font-size: 21px;
                  
                  "> 23.25 </a>
              </div>
            </div>
          </div>

          <div class="secondscreens" *ngIf="showInfo === 'fourth'">
            <h6 style=" font-family: 'DigitalFont';margin:0px;font-weight: bold; font-size: 24px;">
              Avg. PF 
            </h6>
            <div class="row">
            
              <div >
                <a style=" font-family: 'DigitalFont';
                  font-weight: bold;
                  font-size: 27px;
                 text-align: center;
                 "> {{avgpfd}} </a> <br>
               
              </div>
            </div>
          </div>
          <div class="secondscreens" *ngIf="showInfo === 'fifth'">
            <h6 style=" font-family: 'DigitalFont';margin:0px;font-weight: bold; font-size: 24px;">
             Kvah
            </h6>
            <div class="row">
              <div >
                <a style=" font-family: 'DigitalFont';
                  font-weight: bold;
                  font-size: 27px;
                 text-align: center;">
                1344 </a> <br>
               
              </div>
            </div>
          </div> -->
          <div class="row" style="margin-top: 1px; margin-bottom: 1px;">
         <!-- <div *ngIf="showInfo === 'third'">
              <button style="background-color: #14721F; height: 24px; ">
             <i class="fas fa-chevron-left" style="color: black;"></i>
            </button>
            </div>
            <div *ngIf="showInfo === 'second'">
              <button style="background-color: #14721F; height: 24px; ">
                <i class="fas fa-chevron-left" style="color: black;"></i>
            </button>
            </div>

            <button style="background-color: #14721F; height: 24px;margin-left: 30px;" (click)="incrementkwh()">
              <i class="fas fa-angle-up" style="color: black;"></i>
            </button>
            <button style="background-color: #14721F; height: 24px; margin-left: 30px;" (click)="showcurrent()">
              <i class="fas fa-angle-down" style="color: black;"></i>
            </button>-->
            <button style="background-color: #14721F; height: 24px;margin-top: 3px;" >
              <i class="fas fa-sync-alt" style="color: black;"></i>
            </button>
          </div>
        </div>
      </div>

      <div class="col-md-4 Mpadding custom-scrollbar">
        <mat-card class="Mpadding" style="padding:0px;overflow: hidden;overflow-y: scroll;background-color: rgba(37, 81, 37, 0.826);">
       <!-- <mat-card-header class="energy-card-header " style="background-color: rgb(23, 47, 23);" >
            <b style="text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.5);color: #FFFFFF;float: left;"> <b style="color: white; text-align: center;font-size: 2vh;">Suggestions</b>
              <button class="speaker-button" (click)="toggleSpeaker()">
                <i class="fas" [ngClass]="speakerOn ? 'fa fa-eye' : 'fa fa-eye-slash'"></i>
              </button></b>
         </mat-card-header>
          <mat-card-content>
            <div class="scrollable-wrapper" *ngIf="!muteSuggestions" (mouseover)="stopAnimations()" (mouseout)="startAnimations()">
              <ul class="suggestion-list" >
                <li class="suggestion-item">
                  <h4 class="suggestion-heading fontSize">{{ SuggestionsTileData() }}</h4>
                  <span class="suggestion-content fontSize">{{ getPowerFactorSuggestion() }}</span>
                </li>
              </ul>
            </div>
            
          </mat-card-content> -->
          <mat-card-header class="energy-card-header " style="background-color: rgb(0, 82, 0);" >
            <b style="text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.5);color: #FFFFFF;float: left;"> <b style="color: white; text-align: center;font-size: 2vh;">Current Month Energy Balance</b>
             </b>
         </mat-card-header>
         <mat-card-content>
          <div  style="height:22vh;" id="energyBalance"></div>
        </mat-card-content>
        </mat-card>
      </div>
      
  
      
    </div>

   

    <div class="row " style="padding:3px;">
      <div class="col-md-6 ">
        <mat-card class="paddings" style="background-color: rgba(29, 85, 90, 0.578);">
          <mat-card-content>
            <div  style="height:29vh;" #consumption_graph_mb></div>
          </mat-card-content>
        </mat-card>
      </div>
     
      <div class="col-md-6 "  >
            <mat-card class="paddings"  style=" background-color: rgba(25, 63, 78, 0.678);">
              <mat-card-content>
                <div  style="height:29vh;" #minutewiseConsumption></div>
              </mat-card-content>
            </mat-card>
      </div>
    </div>



  </div>
</div>